import { Outlet } from 'react-router-dom'
import { useMatches } from 'react-router-dom'
import {
  Breadcrumb,
  Breadcrumbs as BreadcrumbsBase,
  Toast
} from '@chilecompra/react-kit/components'
import styled from 'styled-components'

import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment.config'
import NotFoundPage from '../../pages/NotFound.page'
import ProtectByProfile from './ProtectByProfile'

const Breadcrumbs = styled(BreadcrumbsBase)`
  && {
    margin: 0;
    padding: 0;
    a {
      color: ${props => props.theme.palette.brand.primary};
    }
  }
`

/**
 * The ProtectedLayout component.
 */
const ProtectedLayout = () => {
  const matches = useMatches()
  const breadcrumbLabel = matches.at(-1)?.handle?.breadcrumb

  const URL = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`

  const handleBack = () => (window.location.href = URL)

  const fallback = () => (
    <>
      <Toast border severity="info" textDirection="vertical" width="100%">
        Debes ingresar como proveedor
      </Toast>
      <NotFoundPage />
    </>
  )

  return (
    <>
      <Breadcrumbs>
        <Breadcrumb onClick={handleBack} target="_top" to={URL} type="external" variant="link">
          Escritorio
        </Breadcrumb>
        <Breadcrumb variant="text">{breadcrumbLabel}</Breadcrumb>
      </Breadcrumbs>

      <ProtectByProfile fallback={fallback} rule={userType => userType === 'Proveedor'}>
        <Outlet />
      </ProtectByProfile>
    </>
  )
}

export default ProtectedLayout
